import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=9278692a&scoped=true"
import script from "./BusinessInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9278692a",
  null
  
)

export default component.exports